module.exports = __webpack_public_path__ + "static/cf-med-56978a9d654da502d3b6ef6f5deaef1d.woff";